export const donationRecurringFrequency = {
    daily: "daily",
    weekly: "weekly",
    monthly: "monthly"
};

export const donationRecurringFrequencyAbbreviate = {
    daily: "day",
    weekly: "wk",
    monthly: "mth"
};

export const defaultDonationAmounts = [
    { isDefault: true, amount: 20, description: '', image: '' },
    { isDefault: false, amount: 50, description: '', image: '' },
    { isDefault: false, amount: 75, description: '', image: '' },
    { isDefault: false, amount: 100, description: '', image: '' }
];
